import { createFeature, createReducer, on, createSelector, createAction, props } from '@ngrx/store';
import { CommonApiState } from './common';
import { GetWorkspacesQueryParams, Workspace } from '../models/workspaces';

export const WorkspaceListFetch = createAction('[WorkspaceList] Fetch', props<GetWorkspacesQueryParams>());
export const WorkspaceListFetched = createAction('[WorkspaceList] Fetched', props<{ workspaceList: Workspace[] }>());
export const WorkspaceListError = createAction('[WorkspaceList] Error');

export const WorkspaceFetch = createAction('[Workspace] Fetch', props<{ workspaceId: string }>());
export const WorkspaceFetched = createAction(
  '[Workspace] Fetched',
  props<{ workspaceId: string; workspace: Workspace }>()
);
export const WorkspaceError = createAction('[Workspace] Error');

export const initialState: CommonApiState<Workspace[]> = {
  data: [],
  currentPedingApis: 0,
  isError: false
};

export const workspaceListFeature = createFeature({
  name: 'workspaceList',
  reducer: createReducer(
    initialState,
    on(WorkspaceListFetch, state => ({
      ...state,
      currentPedingApis: state.currentPedingApis + 1
    })),
    on(WorkspaceListFetched, (state, result) => {
      return {
        ...state,
        currentPedingApis: 0,
        isError: false,
        data: result.workspaceList
      };
    }),
    on(WorkspaceFetched, (state, result) => {
      const currentWorkspace = state.data.find(workspace => workspace.id === result.workspaceId);
      const updatedWorkspaces = [...state.data.filter(workspace => workspace !== currentWorkspace)];
      updatedWorkspaces.push({ ...currentWorkspace, ...result.workspace });

      return {
        ...state,
        currentPedingApis: 0,
        isError: false,
        data: updatedWorkspaces
      };
    }),
    on(WorkspaceListError, state => {
      return {
        ...state,
        currentPedingApis: 0,
        isError: true
      };
    })
  ),
  extraSelectors: ({ selectWorkspaceListState }) => {
    const workspaceListsIsLoading = createSelector(
      selectWorkspaceListState,
      WorkspaceListState => WorkspaceListState.currentPedingApis > 0
    );

    //Don't let 2 or more action start another request
    const workspaceListHasPendingRequest = createSelector(
      selectWorkspaceListState,
      WorkspaceListState => WorkspaceListState.currentPedingApis >= 2
    );
    const workspaceById = (workspaceId: string) => {
      return createSelector(selectWorkspaceListState, workspaces => {
        return workspaces.data.find(workspace => workspace.id === workspaceId);
      });
    };

    return { workspaceListsIsLoading, workspaceListHasPendingRequest, workspaceById };
  }
});
